export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/czyc@2x-82ca929bf6b2824f1fdc630913a9a615.png";